module.exports = __webpack_public_path__ + "img/success_icon.d2347a48.svg";